"use client";

import type { ToolUIRegistry } from "@magnus/react";
import { lazy } from "react";

const outlookStatusView = () =>
  import("@/components/chat/outlook-tool-status").then(
    ({ OutlookToolStatusView }) => ({ default: OutlookToolStatusView })
  );

const step = (loader: typeof outlookStatusView) => ({
  kind: "step" as const,
  category: "code" as const,
  view: lazy(loader),
});

export const outlookToolRegistry = {
  get_current_email_id: step(outlookStatusView),
  display_reply_form: step(outlookStatusView),
  display_reply_all_form: step(outlookStatusView),
  display_new_email_form: step(outlookStatusView),
  set_compose_subject: step(outlookStatusView),
  set_compose_body: step(outlookStatusView),
  add_compose_recipients: step(outlookStatusView),
  add_compose_attachment: step(outlookStatusView),
  save_compose_draft: step(outlookStatusView),
} satisfies ToolUIRegistry;
